<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <div class="row hidden-row"></div>

      <div class="row">
        <div class="col-12 my-5">
          <h5>
            <unicon :name="'heart'" :fill="secCol" style="margin-right: 8px;" />
            <span>Desafíos Favoritos</span>
          </h5>
        </div>
      </div>

      <div class="row">
        <template v-if="challenges.length">
          <template v-for="(challenge, i) in challenges">
            <ChallengeCard
              :key="i"
              @openCard="openCard(challenge)"
              :cardData="challenge"
              :img="challenge.categories[0].nombre"
            />
          </template>
        </template>
      </div>

      <div class="row" v-if="showSpinner">
        <div class="col-12 text-center">
          <Spinner />
        </div>
      </div>
      <div class="row" v-if="!showSpinner && !challenges.length">
        <div class="col-12 text-center">
          No hay favoritos para mostrar
        </div>
      </div>

      <ChallengeDetailModal
        :challengeData="challengeData"
        v-if="showModal.challengeDetail"
        @close="showModal.challengeDetail = false"
      />

      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChallengeCard from "@/components/ChallengeCard";
import ChallengeDetailModal from "@/components/challenge/ModalChallenge";
import FooterComponent from "@/components/Footer";
import Spinner from "@/components/Spinner";

export default {
  name: "Challenges",
  components: {
    ChallengeCard,
    ChallengeDetailModal,
    FooterComponent,
    Spinner,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      showModal: {
        challengeDetail: false,
      },
      challenges: [],
      challengeData: null,
      currentPage: 0,
      totalPages: null,
      category: null,
      categoryImg: null,
      sizeList: 12,
      showSpinner: false,
      challenge: {
        name: null,
      },
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData"]),
  },
  methods: {
    openCard(data) {
      this.challengeData = data;
      this.showModal.challengeDetail = true;
    },
    async getChallenges() {
      let apiUrl = `${this.dataUrl}/testFavorite/getFavoriteTestsByUser?userId=${this.teacherData.id}`;

      this.challenges = [];
      this.showSpinner = true;

      try {
        let { data } = await this.axios.get(apiUrl);

        this.challenges = data.content;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        this.showSpinner = false;
      }
    },
  },
  mounted() {
    this.getChallenges();
  },
};
</script>
